import { CALL_FUNDS_DISTRIBUTION_API } from '../../middleware/authHeaders'
import {
  ACCEPT_JSON_HEADERS,
  FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT,
} from '../../config/api'
import { infoNotification, errorNotification } from '../application/notifications'

export const GET_PROCESSING_GLOBAL_CONFIG_REQUEST = 'GET_PROCESSING_GLOBAL_CONFIG_REQUEST'
export const GET_PROCESSING_GLOBAL_CONFIG_SUCCESS = 'GET_PROCESSING_GLOBAL_CONFIG_SUCCESS'
export const GET_PROCESSING_GLOBAL_CONFIG_FAILURE = 'GET_PROCESSING_GLOBAL_CONFIG_FAILURE'

export const getGlobalConfig = () => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'GET',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/global-config`,
      types: [
        GET_PROCESSING_GLOBAL_CONFIG_REQUEST,
        GET_PROCESSING_GLOBAL_CONFIG_SUCCESS,
        GET_PROCESSING_GLOBAL_CONFIG_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error getting processing service global configuration`,
          dismissInSeconds: 10,
        })
      )
    }
  })
}

export const POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_REQUEST =
  'POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_REQUEST'
export const POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_SUCCESS =
  'POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_SUCCESS'
export const POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_FAILURE =
  'POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_FAILURE'

export const toggleAutomaticCreation = enabled => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/global-config/toggle-automatic-payment-creation`,
      types: [
        POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_REQUEST,
        POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_SUCCESS,
        POST_PROCESSING_TOGGLE_AUTOMATIC_CREATION_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({ enabled }),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error ${enabled ? 'enabling' : 'disabling'} automatic payment creation`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        infoNotification({
          body: `Automatic payment creation is ${enabled ? 'enabled' : 'disabled'}`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

export const POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_REQUEST =
  'POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_REQUEST'
export const POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_SUCCESS =
  'POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_SUCCESS'
export const POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_FAILURE =
  'POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_FAILURE'

export const toggleAutomaticPaymentProcessing = enabled => dispatch => {
  dispatch({
    [CALL_FUNDS_DISTRIBUTION_API]: {
      method: 'POST',
      endpoint: `${FUNDS_DISTRIBUTION_PAYMENT_PROCESSING_API_ROOT}/processing/global-config/toggle-automatic-payment-processing`,
      types: [
        POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_REQUEST,
        POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_SUCCESS,
        POST_PROCESSING_TOGGLE_AUTOMATIC_PROCESSING_FAILURE,
      ],
      headers: {
        ...ACCEPT_JSON_HEADERS,
      },
      body: JSON.stringify({ enabled }),
    },
  }).then(response => {
    if (response.error) {
      dispatch(
        errorNotification({
          body: `Error ${enabled ? 'enabling' : 'disabling'} automatic payment processing`,
          dismissInSeconds: 10,
        })
      )
    } else {
      dispatch(
        infoNotification({
          body: `Automatic payment processing is ${enabled ? 'enabled' : 'disabled'}`,
          dismissInSeconds: 5,
        })
      )
    }
  })
}

// SELECTORS
export const selectGlobalConfig = state => state.fundsDistribution.globalConfig

// STATE
export const INITIAL_STATE = {
  enableAutomaticPaymentCreation: false,
  enableAutomaticPaymentProcessing: false,
}

// REDUCERS
const globalConfig = (state = INITIAL_STATE, { type, payload } = {}) =>
  ({
    [GET_PROCESSING_GLOBAL_CONFIG_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      ...newPayload,
    }),
  }[type]?.(state, payload) || state)

export default globalConfig
